import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";


const state = {

    courses: [],
    totalItems: 0,
};

const getters = {
};

const mutations = {

    setCourses: (state, r) => (state.courses = r),
    setTotalItems: (state, r) => (state.totalItems = r),

};

const actions = {


    async getCourses({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.courses.getCourses(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setCourses", response.data.courses);

            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },





};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
